import { ENDPOINTS } from "utils/endpoints";
import { GET_API_CALL, POST_API_CALL } from "utils/services";
import { APIResponseModal } from "utils/modals";
import SHOW_TOAST from "utils/showToast";

export const savePrivacyPolicy = (data: any, callback: Function) => {
  return (dispatch: Function) => {
    POST_API_CALL(
      ENDPOINTS.CMS.PRIVACY_POLICY,
      data.data,
      (response: APIResponseModal) => {
        if (response.isSuccess) {
          const { message } = response?.data;
          SHOW_TOAST(message, "success");
        }
        callback(response);
      }
    );
  };
};

export const saveTermsCondition = (data: any, callback: Function) => {
  return (dispatch: Function) => {
    POST_API_CALL(
      ENDPOINTS.CMS.TERM_AND_CONDITION,
      data.data,
      (response: APIResponseModal) => {
        if (response.isSuccess) {
          const { message } = response?.data;
          SHOW_TOAST(message, "success");
        }
        callback(response);
      }
    );
  };
};

export const getTermsCondition = (data: any, callback: Function) => {
  return (dispatch: Function) => {
    GET_API_CALL(
      ENDPOINTS.CMS.GET_TERM_AND_CONDITION,
      "",
      (response: APIResponseModal) => {
        if (response.isSuccess) {
          callback && callback(response?.data);
          return;
        }
        callback();
      }
    );
  };
};

export const getPrivacyPolicy = (data: any, callback: Function) => {
  return (dispatch: Function) => {
    GET_API_CALL(
      ENDPOINTS.CMS.GET_PRIVACY_POLICY,
      "",
      (response: APIResponseModal) => {
        if (response.isSuccess) {
          callback && callback(response?.data);
          return;
        }
        callback();
      }
    );
  };
};
